<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="logo">
      <img src="@/assets/img/mayologo.png" />
    </div>
    <div class="menu">
      <div class="left">
        <h1>Our Facility</h1>
        <div class="line"></div>
        <div class="menu-item">
          <p
            id="overview"
            @click="toggleActive"
            :class="{ active: current === 'overview' }"
          >
            Overview
          </p>
          <img src="@/assets/img/go.png" />
        </div>

        <div class="menu-item">
          <p
            id="manufacturing"
            @click="toggleActive"
            :class="{ active: current === 'manufacturing' }"
          >
            Learn About Additive Manufacturing
          </p>
          <img src="@/assets/img/go.png" />
        </div>

        <div class="menu-item">
          <p
            id="equipment"
            @click="toggleActive"
            :class="{ active: current === 'equipment' }"
          >
            Our State of the Art Equipment
          </p>
          <img src="@/assets/img/go.png" />
        </div>

        <div class="menu-item">
          <p
            id="process"
            @click="toggleActive"
            :class="{ active: current === 'process' }"
          >
            Our Process
          </p>
          <img src="@/assets/img/go.png" />
        </div>

        <!-- <router-link class="routerlink" to="/ourLab/home"> <h2>Overview <img src="@/assets/img/go.png"></h2></router-link>
        <router-link class="routerlink" to="/process/home"><h2>Process <img src="@/assets/img/go.png"></h2></router-link>
        <router-link class="routerlink" to="/facility/home"><h2>Facility <img src="@/assets/img/go.png"></h2></router-link> -->
      </div>

      <div class="right">
        <transition>
          <div class="overview" v-if="current === 'overview'">
            <h3>Overview</h3>
            <p>
              Welcome to the Mayo Clinic Division of Engineering Additive
              Manufacturing Facility. Our dedicated additive manufacturing space
              houses a titanium printer, a variety of polymer printers, and a
              suite of post processing equipment. This facility is a strategic
              investment by Mayo Clinic that enables innovation, research, and
              transformation of the clinical practice. The parts manufactured
              here support development of one-of-a-kind medical devices,
              laboratory instruments, and other products in service of Mayo
              Clinic patients. Division of Engineering designers and engineers
              print concept prototypes, working prototypes, and end use products
              for projects undertaken at the request of Mayo Clinic staff
              members. The application of additive manufacturing accelerates the
              development cycle from initial request through final product by
              providing quick turnaround parts. Even beyond accelerating
              innovation and delivering optimum products, our highest goal is to
              design and manufacture patient-specific implants that merge
              engineering and patient anatomy to provide the best possible
              patient outcomes. To this end, we have assembled the best
              equipment and applied exacting quality standard and controls.
            </p>
          </div>
        </transition>

        <transition>
          <div class="manufacturing" v-if="current === 'manufacturing'">
            <h3>Learn About Additive Manufacturing</h3>

            <div class="right-menu">
              <div
                class="card"
                id="test"
                @click="toggleActive"
                :class="{ active: current === 'test' }"
              >
                <p>What is Additive Manufacturing?</p>
              </div>

              <div
                class="card"
                id="test2"
                @click="toggleActive"
                :class="{ active: current === 'test2' }"
              >
                <p>Common Types of 3D Printing</p>
              </div>
            </div>
          </div>
        </transition>

        <transition>
          <div class="equipment" v-if="current === 'equipment'">
            <h3>Our State of the Art Equipment</h3>
            <svg class="facility" viewBox="0 0 926.25 557.99">
              <g class="blocks">
                <path
                  class="block5"
                  @click="popup = 5"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 1H182V132.844V140V144H177V140H138V144H0V140V135V1Z"
                  fill="#1F479A"
                />
                <path
                  class="block3"
                  @click="popup = 3"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M190 0H185V189H190V225H185V297V306V311H229V306H263V311H269V306V297V255H569H575H581V211H575V148H581V128H575V79H581V0H575H569H206H190Z"
                  fill="#1F479A"
                />
                <path
                  class="block4"
                  @click="popup = 4"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 148H182V285V306V311H141V306H85V311H0V306V285V148Z"
                  fill="#1F479A"
                />
                <path
                  class="block1"
                  @click="popup = 1"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M269 315H0V515V517V521H13V517H75V521H112V517H260V521H269V517V515V315Z"
                  fill="#1F479A"
                />
                <path
                  class="block2"
                  @click="popup = 2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M503 259H272V509V517V521H345V517H481H503H554V521H581V515V474H577V322H581V259H575V263H503V259Z"
                  fill="#1F479A"
                />
              </g>

              <path
                d="M134.122 433H139.252V393.31L125.158 398.764V403.678L134.122 400.222V433Z"
                fill="white"
              />
              <path
                d="M412.296 398.892L412.35 399H438.27V394.356H422.61L422.556 394.248L429.36 386.094C433.95 380.586 436.866 376.104 436.866 370.758C436.866 363.252 431.196 359.31 424.284 359.31C420.504 359.31 417.264 360.498 415.266 361.794V366.978C418.02 364.98 421.26 364.062 424.014 364.062C428.55 364.062 431.736 366.492 431.736 371.028C431.736 374.7 429.63 378.102 425.202 383.394L412.296 398.892Z"
                fill="white"
              />
              <path
                d="M98.812 208.904H94.114L73.972 238.442L74.026 238.55H93.736V248H98.812V238.55H105.832V234.014H98.812V208.904ZM88.876 224.078C90.496 221.702 92.224 219.164 93.736 216.734L93.844 216.788C93.79 219.164 93.736 222.08 93.736 224.78V234.014H82.234L82.18 233.906L88.876 224.078Z"
                fill="white"
              />
              <path
                d="M79.024 85.002C81.508 86.568 85.018 87.594 88.852 87.594C97.06 87.594 102.73 82.95 102.73 75.714C102.73 66.804 94.252 63.834 86.152 63.834L86.962 52.548H101.272L101.65 47.904H82.21L80.644 68.64C82.048 68.424 83.614 68.316 85.018 68.316C90.472 68.316 97.6 69.882 97.6 75.93C97.6 80.25 93.928 82.842 88.852 82.842C85.612 82.842 82.318 81.816 79.402 79.656L79.024 85.002Z"
                fill="white"
              />
              <path
                d="M370.862 133.976C373.13 135.974 377.072 137.594 381.608 137.594C389.168 137.594 394.676 133.112 394.676 126.308C394.676 121.988 392.462 118.1 387.602 117.074V116.966C391.436 115.832 393.866 112.484 393.866 108.11C393.866 101.63 388.628 97.31 381.5 97.31C378.314 97.31 375.344 98.174 373.184 99.47V104.708C375.398 103.142 378.314 102.062 381.23 102.062C385.658 102.062 388.736 104.546 388.736 108.596C388.736 112.43 385.982 115.13 381.068 115.13H377.558V119.666H381.23C386.792 119.666 389.546 122.366 389.546 126.2C389.546 130.358 386.198 132.842 381.554 132.842C377.882 132.842 374.102 131.276 370.862 128.09V133.976Z"
                fill="white"
              />
            </svg>

            <div v-if="popup == 1" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Polymer Printing</h3>
                  <div class="line2"></div>
                  <p>
                    The polymer printing area is home to a wide variety of
                    machines. These polymer printers are utilized to create
                    bench top models, prototype medical devices, and finished
                    products out of plastic.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 2" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Metal Printing</h3>
                  <div class="line2"></div>
                  <p>
                    The metal printing space is where our titanium printer
                    resides. This machine is uses medical-grade titanium to
                    create a diverse range of products including medical devices
                    and patient specific implantable devices.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 3" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Post Processing</h3>
                  <div class="line2"></div>
                  <p>
                    The post processing room contains equipment and tools used
                    to transform raw printed parts in to their final form.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 4" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Office/Inspection</h3>
                  <div class="line2"></div>
                  <p>
                    The office/inspection area contains CAD work stations and
                    quality inspection equipment, ensuring the printed articles
                    uphold quality and regulatory requirements.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 5" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Storage</h3>
                  <div class="line2"></div>
                  <p>
                    The storage room contains all raw materials used in the
                    additive manufacturing process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition>
          <div class="process" v-if="current === 'process'">
            <h3>Our Process</h3>
          </div>
        </transition>

        <transition>
          <div class="test" v-if="current === 'test'">
            <h3>What is Additive Manufacturing?</h3>
            <p>
              Additive Manufacturing, or 3D Printing, is a process of
              fabricating three dimensional objects from a digital file. The
              creation process is achieved through laying down successive layers
              of material until the object is created. Each layer can be seen as
              an extremely thin horizontal cross section of the object Additive
              Manufacturing is the opposite of subtractive manufacturing; which
              is creation through removing material.
            </p>
          </div>
        </transition>

        <transition>
          <div class="test2" v-if="current === 'test2'">
            <h3>What is Additive Manufacturing?</h3>
            <p>
              Additive Manufacturing, or 3D Printing, is a process of
              fabricating three dimensional objects from a digital file. The
              creation process is achieved through laying down successive layers
              of material until the object is created. Each layer can be seen as
              an extremely thin horizontal cross section of the object Additive
              Manufacturing is the opposite of subtractive manufacturing; which
              is creation through removing material.
            </p>
            <div class="sub-menu">
              <p>Fused deposition modeling (FDM)</p>
              <p>Stereolithography (SLA)</p>
              <p>Selective Laser Sintering (SLS)</p>
            </div>
          </div>
        </transition>
        <!-- <h3>Overview</h3>
            <p>Welcome to the Mayo Clinic Division of Engineering Additive Manufacturing Facility. Our dedicated additive manufacturing space houses a titanium printer, a variety of polymer printers, and a suite of post processing equipment.</p>
            <p>This facility is a strategic investment by Mayo Clinic that enables innovation, research, and transformation of the clinical practice.</p>
            <p>The parts manufactured here support development of one-of-a-kind medical devices, laboratory instruments, and other products in service of Mayo Clinic patients.</p>
            <p>Division of Engineering designers and engineers print concept prototypes, working prototypes, and end use products for projects undertaken at the request of Mayo Clinic staff members. The application of additive manufacturing accelerates the development cycle from initial request through final product by providing quick turnaround parts.</p>
            <p>Even beyond accelerating innovation and delivering optimum products, our highest goal is to design and manufacture patient-specific implants that merge engineering and patient anatomy to provide the best possible patient outcomes. To this end, we have assembled the best equipment and applied exacting quality standard and controls.</p> -->
      </div>
    </div>

    <router-link to="/Menu/test">
      <div class="btn back">
        <p>Back</p>
      </div>
    </router-link>

    <!-- <div class="btn close"><p>Contact</p></div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "overview",
      popup: null,
      popup: false
    };
  },
  methods: {
    toggleActive(event) {
      this.current = event.target.id;
    }
  }
};
</script>
<style scoped>
h1 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 80px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 0;
}

h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  /* width: 500px; */
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 30px 0;
}

.btn {
  background-color: rgba(255, 255, 255, 0.1);
  /* width: 100px;
  height: 50px;  */
}

.card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.3);
  width: 48%;
  margin: 1%;
  height: 165px;
  /* border: 2px solid white; */
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 10px;
}

.card p {
  position: relative;
  font-size: 33px;
  padding-bottom: 10px;
  /* padding-top: 10px; */
  color: #ffffff;
  font-family: AzoSans;
  margin: 0;
  text-align: center;
}

/* .right {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 55%;
    justify-content: space-evenly;
    padding-left: 500px;
} */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
